'use client';

import React from 'react';
import { Clock } from 'lucide-react';

interface DurationDisplayProps {
  duration: string;
}

const DurationDisplay: React.FC<DurationDisplayProps> = ({ duration }) => {
  if (!duration) return null;
  
  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4">
      <div className="flex items-center space-x-2">
        <Clock className="w-5 h-5 text-green-600" />
        <span className="text-green-800 font-semibold text-base">Duration: {duration}</span>
      </div>
    </div>
  );
};

export default DurationDisplay;